// TODO: Abstract the use of these images to use vector-image service
import iconImage from './assets/Light.png';

const { host } = window.location;
let domain = host;
if (host !== 'deckee.com') domain = 'staging.deckee.com';

export default {
  displayName: 'Light',
  iconImage,
  iconBackgroundColor: '#ADE1FE',
  subscriberOnly: true,
  style: `https://${domain}/public/map-tile-server/map-styles/light.json`,
};
